import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import API_BASE_URL from "../config/api";


function Papers() {

    /*
    |--------------------------------------------------------------------------
    | Papers
    |--------------------------------------------------------------------------
    */

    const [papers, setPapers] = useState([]);


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    const [loading, setLoading] = useState(true);


    /*
    |--------------------------------------------------------------------------
    | Search
    |--------------------------------------------------------------------------
    */

    const [search, setSearch] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Pagination
    |--------------------------------------------------------------------------
    */

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;


    /*
    |--------------------------------------------------------------------------
    | Fetch Papers
    |--------------------------------------------------------------------------
    */

    const fetchPapers = async () => {

        try {

            setLoading(true);


            const response = await fetch(
                `${API_BASE_URL}/admin/papers`,
                {
                    method: "GET",

                    headers: {
                        "Accept": "application/json"
                    },

                    credentials: "include"
                }
            );


            const data = await response.json();


            console.log(
                "Papers Response:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Success
            |--------------------------------------------------------------------------
            */

            if (
                response.ok &&
                data.success
            ) {

                setPapers(
                    data.data || []
                );

            } else {

                Swal.fire({

                    icon: "error",

                    title: "Unable to Load Papers",

                    text:
                        data.message ||
                        "Unable to fetch papers."

                });

            }


        } catch (error) {

            console.error(
                "Fetch Papers Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Server Error",

                text:
                    "Unable to connect with server."

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Fetch On Page Load
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        fetchPapers();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Delete Paper
    |--------------------------------------------------------------------------
    */

    const handleDelete = async (id) => {


        const result =
            await Swal.fire({

                icon: "warning",

                title: "Delete Paper?",

                text:
                    "Are you sure you want to delete this paper?",

                showCancelButton: true,

                confirmButtonText:
                    "Yes, Delete",

                cancelButtonText:
                    "Cancel",

                confirmButtonColor:
                    "#dc3545",

                cancelButtonColor:
                    "#6c757d"

            });


        if (!result.isConfirmed) {

            return;

        }


        try {

            const response = await fetch(

                `${API_BASE_URL}/admin/papers/${id}`,

                {

                    method: "DELETE",

                    headers: {

                        "Accept":
                            "application/json"

                    },

                    credentials: "include"

                }

            );


            const data =
                await response.json();


            console.log(
                "Delete Paper Response:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Delete Success
            |--------------------------------------------------------------------------
            */

            if (
                response.ok &&
                data.success
            ) {


                setPapers(
                    (previousPapers) =>
                        previousPapers.filter(
                            (item) =>
                                item.paper_id !== id
                        )
                );


                await Swal.fire({

                    icon: "success",

                    title: "Deleted!",

                    text:
                        data.message ||
                        "Paper deleted successfully.",

                    timer: 1500,

                    showConfirmButton: false

                });


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Delete Failed
            |--------------------------------------------------------------------------
            */

            Swal.fire({

                icon: "error",

                title: "Delete Failed",

                text:
                    data.message ||
                    "Unable to delete paper."

            });


        } catch (error) {

            console.error(
                "Delete Paper Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Server Error",

                text:
                    "Unable to connect with server."

            });

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Search Filter
    |--------------------------------------------------------------------------
    */

    const filteredPapers =
        papers.filter((item) => {

            const searchText =
                search
                    .toLowerCase()
                    .trim();


            if (!searchText) {

                return true;

            }


            return (

                String(item.paper_id)
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(item.paper_type)
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(item.paper)
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(item.category)
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(item.exam_date)
                    .toLowerCase()
                    .includes(searchText)

            );

        });


    /*
    |--------------------------------------------------------------------------
    | Total Pages
    |--------------------------------------------------------------------------
    */

    const totalPages =
        Math.ceil(
            filteredPapers.length /
            itemsPerPage
        );


    /*
    |--------------------------------------------------------------------------
    | Current Page Data
    |--------------------------------------------------------------------------
    */

    const startIndex =
        (currentPage - 1) *
        itemsPerPage;


    const endIndex =
        startIndex +
        itemsPerPage;


    const currentPapers =
        filteredPapers.slice(
            startIndex,
            endIndex
        );


    /*
    |--------------------------------------------------------------------------
    | Search Change
    |--------------------------------------------------------------------------
    */

    const handleSearch = (e) => {

        setSearch(
            e.target.value
        );

        /*
        |----------------------------------------------------------------------
        | Search करने पर first page
        |----------------------------------------------------------------------
        */

        setCurrentPage(1);

    };


    /*
    |--------------------------------------------------------------------------
    | Previous Page
    |--------------------------------------------------------------------------
    */

    const handlePrevious = () => {

        if (currentPage > 1) {

            setCurrentPage(
                currentPage - 1
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Next Page
    |--------------------------------------------------------------------------
    */

    const handleNext = () => {

        if (currentPage < totalPages) {

            setCurrentPage(
                currentPage + 1
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Page Correction
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (
            totalPages > 0 &&
            currentPage > totalPages
        ) {

            setCurrentPage(
                totalPages
            );

        }


        if (
            totalPages === 0 &&
            currentPage !== 1
        ) {

            setCurrentPage(1);

        }

    }, [
        totalPages,
        currentPage
    ]);


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="container-fluid">

                <div
                    className="
                        d-flex
                        justify-content-center
                        align-items-center
                    "
                    style={{
                        minHeight: "400px"
                    }}
                >

                    <div
                        className="spinner-border text-primary"
                        role="status"
                    >

                        <span className="visually-hidden">
                            Loading...
                        </span>

                    </div>

                </div>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | JSX
    |--------------------------------------------------------------------------
    */

    return (

        <div className="container-fluid">


            {/* ================================================================
                HEADER
            ================================================================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-4
                "
            >

                <h3 className="mb-0">

                    Papers

                </h3>


                <Link
                    to="/add-paper"
                    className="btn btn-primary"
                >

                    + Add Paper

                </Link>

            </div>


            {/* ================================================================
                CARD
            ================================================================= */}

            <div className="card shadow-sm">


                {/* ============================================================
                    SEARCH
                ============================================================= */}

                <div className="card-header bg-white">

                    <div className="row">

                        <div className="col-md-5">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Paper..."
                                value={search}
                                onChange={
                                    handleSearch
                                }
                            />

                        </div>

                    </div>

                </div>


                {/* ============================================================
                    TABLE
                ============================================================= */}

                <div className="card-body p-0" style={{
                            maxHeight: "350px",
                            overflowX: "auto",
                            overflowY: "auto"
                        }}>

                    <div
                        className="table-responsive"
                        style={{
                            overflowX: "auto"
                        }}
                    >

                        <table
                            className="
                                table
                                table-hover
                                align-middle
                                mb-0
                            "
                        >

                            <thead className="table-light">

                                <tr>

                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Paper Type
                                    </th>

                                    <th>
                                        Paper
                                    </th>

                                    <th>
                                        Category
                                    </th>

                                    <th>
                                        Exam Date
                                    </th>

                                    <th
                                        style={{
                                            minWidth: "180px"
                                        }}
                                    >
                                        Action
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {currentPapers.length > 0 ? (

                                    currentPapers.map(
                                        (item, index) => (

                                            <tr
                                                key={
                                                    item.paper_id
                                                }
                                            >

                                                <td>

                                                    {startIndex +
                                                        index +
                                                        1}

                                                </td>


                                                <td>

                                                    <span
                                                        className="
                                                            badge
                                                            bg-primary
                                                        "
                                                    >

                                                        {
                                                            item.paper_type
                                                        }

                                                    </span>

                                                </td>


                                                <td>

                                                    <strong>

                                                        {
                                                            item.paper
                                                        }

                                                    </strong>

                                                </td>


                                                <td>

                                                    {
                                                        item.category
                                                    }

                                                </td>


                                                <td>

                                                    {
                                                        item.exam_date
                                                    }

                                                </td>


                                                <td>

                                                    <Link
                                                        to={`/edit-paper/${item.paper_id}`}
                                                        className="
                                                            btn
                                                            btn-sm
                                                            btn-warning
                                                            me-2
                                                        "
                                                    >

                                                        Edit

                                                    </Link>


                                                    <button
                                                        type="button"
                                                        className="
                                                            btn
                                                            btn-sm
                                                            btn-danger
                                                        "
                                                        onClick={() =>
                                                            handleDelete(
                                                                item.paper_id
                                                            )
                                                        }
                                                    >

                                                        Delete

                                                    </button>

                                                </td>

                                            </tr>

                                        )

                                    )

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="6"
                                            className="
                                                text-center
                                                py-5
                                                text-muted
                                            "
                                        >

                                            {search

                                                ? "No papers found for your search."

                                                : "No papers available."

                                            }

                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* ============================================================
                    FOOTER
                ============================================================= */}

                <div className="card-footer bg-white">


                    <div
                        className="
                            d-flex
                            justify-content-between
                            align-items-center
                        "
                    >


                        {/* ----------------------------------------------------
                            Showing
                        ----------------------------------------------------- */}

                        <div>

                            <small className="text-muted">

                                {filteredPapers.length > 0 ? (

                                    <>
                                        Showing{" "}
                                        <strong>
                                            {startIndex + 1}
                                        </strong>

                                        {" "}to{" "}

                                        <strong>
                                            {Math.min(
                                                endIndex,
                                                filteredPapers.length
                                            )}
                                        </strong>

                                        {" "}of{" "}

                                        <strong>
                                            {filteredPapers.length}
                                        </strong>

                                        {" "}papers
                                    </>

                                ) : (

                                    <>
                                        Showing{" "}
                                        <strong>
                                            0
                                        </strong>
                                        {" "}papers
                                    </>

                                )}

                            </small>

                        </div>


                        {/* ----------------------------------------------------
                            Previous / Next
                        ----------------------------------------------------- */}

                        {totalPages > 1 && (

                            <div
                                className="
                                    d-flex
                                    gap-2
                                "
                            >

                                {/* Previous */}

                                <button
                                    type="button"
                                    className="
                                        btn
                                        btn-sm
                                        btn-outline-primary
                                    "
                                    onClick={
                                        handlePrevious
                                    }
                                    disabled={
                                        currentPage === 1
                                    }
                                >

                                    &laquo; Previous

                                </button>


                                {/* Current Page */}

                                <span
                                    className="
                                        btn
                                        btn-sm
                                        btn-primary
                                    "
                                >

                                    Page{" "}
                                    {currentPage}
                                    {" "}
                                    of{" "}
                                    {totalPages}

                                </span>


                                {/* Next */}

                                <button
                                    type="button"
                                    className="
                                        btn
                                        btn-sm
                                        btn-outline-primary
                                    "
                                    onClick={
                                        handleNext
                                    }
                                    disabled={
                                        currentPage ===
                                        totalPages
                                    }
                                >

                                    Next &raquo;

                                </button>

                            </div>

                        )}

                    </div>

                </div>


            </div>

        </div>

    );

}


export default Papers;